<div class="fnol-item" (click)="openInvoiceDocument()">
  <div class="part">
    <div class="pet-name">
      <p class="subtitle-14">{{ fnolRequest.fnolPetName }}</p>
    </div>

    <div class="reporting-date">
      <p class="body-12">{{ fnolRequest.notificationDate | date: 'dd.MM.yyyy' }}</p>
    </div>
  </div>

  <div class="part">
    <div class="status" [ngClass]="getStatusClass(fnolRequest.processingStatusAgg)">
      <p class="tag-12">{{ formatStatus(fnolRequest.processingStatusAgg) | translate }}</p>
    </div>
  </div>

  @if (fnolRequest.invoiceDocument?.s3Id) {
    <button class="button icon-only pdf-action"
      (click)="$event.stopPropagation(); openInvoiceDocument()">
      <mat-icon svgIcon="download-light"></mat-icon>
    </button>
  }
</div>
